import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseUpdateMeRequest, UseUpdateMeData, UseUpdateNotificationSettingsRequest, UseUpdateNotificationSettingsData, UseUpdatePasswordRequest, UseUpdatePasswordData, UseWithdrawRequest, UseWithdrawData } from "@api/@types/me";

export const useUpdateMe = createApiMutation<UseUpdateMeData, UseUpdateMeRequest>({
  mutationFn: (req) => apiClientManager.apis.me.updateMe(req as UseUpdateMeRequest),
});

export const useUpdateNotificationSettings = createApiMutation<UseUpdateNotificationSettingsData, UseUpdateNotificationSettingsRequest>({
  mutationFn: (req) => apiClientManager.apis.me.updateNotificationSettings(req as UseUpdateNotificationSettingsRequest),
});

export const useUpdatePassword = createApiMutation<UseUpdatePasswordData, UseUpdatePasswordRequest>({
  mutationFn: (req) => apiClientManager.apis.me.updatePassword(req as UseUpdatePasswordRequest),
});

export const useWithdraw = createApiMutation<UseWithdrawData, UseWithdrawRequest>({
  mutationFn: (req) => apiClientManager.apis.me.withdraw(req as UseWithdrawRequest),
});

export type { UseUpdateMeRequest, UseUpdateMeData, UseUpdateNotificationSettingsRequest, UseUpdateNotificationSettingsData, UseUpdatePasswordRequest, UseUpdatePasswordData, UseWithdrawRequest, UseWithdrawData } from "@api/@types/me";
